module.exports = {
  isZeroOrPositiveInteger: (number) => {
    return (number && ((typeof number === 'number' && number >= 0) || (typeof number === 'string' && number.match(/^[0-9]+$/)))) || number === 0
  },
  isZeroOrPositiveNumber: (number) => {
    return (number && ((typeof number === 'number' && number >= 0) || (typeof number === 'string' && number.match(/^\d+(\.\d{1,2})?$/)))) || number === 0
  },
  isPositiveInteger: (number) => {
    return number && ((typeof number === 'number' && number > 0) || (typeof number === 'string' && number.match(/^[1-9]+[0-9]*$/)))
  },
  isNegativeInteger: (number) => {
    return number && ((typeof number === 'number' && number < 0) || (typeof number === 'string' && number.match(/^-[1-9]+[0-9]*$/)))
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascript/numberutil.js